//import "bootstrap/dist/css/bootstrap.min.css";
//import "./wdyr";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { ThemeProvider } from "@material-ui/styles";
import muiTheme from "./theme/muiTheme";
import updateServiceworker from "./reducers/serviceWorker";

import config from "./app.config";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

import reducers from "./reducers/index";

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from "react-query";

import { DataProvider } from "./components/common/DataContext";
import { Theme } from '@radix-ui/themes';
import "./App.css";
import { LDProvider, useLDClient } from "launchdarkly-react-client-sdk";
import { useOktaAuth } from "@okta/okta-react";
import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";
import { getToken, getAccessToken } from "./actions/Okta";
import { ENDPOINTS } from "./app.config";


const history = createBrowserHistory();


var middleWares = {};

if (process.env.NODE_ENV === "production") {
  middleWares = applyMiddleware(thunk);
} else {
  middleWares = applyMiddleware(logger, thunk);
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(middleWares));
/* eslint-enable */

// const auth = new Auth({
//   history,
//   issuer: config.issuer,
//   client_id: config.client_id,
//   redirect_uri: config.redirect_uri,
//   onAuthRequired: ({ history }) => history.push("/login")
// });
const oktaAuth = new OktaAuth({
  issuer: config.issuer,
  clientId: config.client_id,
  redirectUri: config.redirect_uri,
  scopes: ["openid", "profile", "email"],
  pkce: true,
  devMode: true,
  tokenManager: {
    storage: 'localStorage',
  },
});

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
};

const queryClient = new QueryClient({
  defaultOptions: {
    // configure cacheTime or staleTime if needed - default is cache is 5 minutes and staleTime is 0
  },
});

const onUpdate = () => {
  store.dispatch(updateServiceworker());
};

function LDIdentifier() {
  const ldClient = useLDClient();
  const { authState } = useOktaAuth();
  const isAuthenticated = authState && authState.isAuthenticated;

  React.useEffect(() => {
    if (!isAuthenticated || !ldClient) return;

    const tokenData = getToken();
    const claims = (tokenData && tokenData.idToken && tokenData.idToken.claims) || {};
    if (!claims.sub) return;

    const accessToken = getAccessToken();
    if (!accessToken) return;

    fetch(`${ENDPOINTS.main}/user/profile`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then(function(r) { return r.json(); })
      .then(function(resp) {
        var data = (resp && resp.data) || {};
        return ldClient.identify({
          kind: "user",
          key: claims.sub,
          email: data.email || claims.email || "",
          group: data.group || "RND",
        });
      })
      .catch(function() {});
  }, [isAuthenticated, ldClient]);

  return null;
}

function LDWrapper({ children }) {
  const initialContext = {
    kind: "user",
    key: "anonymous",
    anonymous: true,
    email: "",
    group: "RND",
  };

  return (
    <LDProvider clientSideID={config.ldClientSideId || "6a209f98d1b0830a9d7358d4"} context={initialContext}>
      <LDIdentifier />
      {children}
    </LDProvider>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <ThemeProvider theme={muiTheme}>
        {/* Refactoring to Radix themes - both MUI and Radix will be on for a few till we port over  */}
        <Theme accentColor="green">
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <LDWrapper>
              <QueryClientProvider client={queryClient}>
                <DataProvider>

                  <App />

                </DataProvider>
                <ReactQueryDevtools />
              </QueryClientProvider>
            </LDWrapper>
          </Security>
        </Theme>
      </ThemeProvider>

    </Router>

  </Provider>,
  document.getElementById("root")
);
// The legacy CRA build registered a Workbox service worker; the vanilla webpack
// build no longer does. Returning users still have that stale SW controlling the
// page and serving precached/old bundles, which surfaces as
// "Uncaught SyntaxError: Unexpected token '<'". Actively unregister it so they
// recover on next load. Re-registration stays disabled.
unregisterServiceWorker();
